import { render } from "./EditarViaje.vue?vue&type=template&id=a195a72a&scoped=true"
import script from "./EditarViaje.vue?vue&type=script&lang=js"
export * from "./EditarViaje.vue?vue&type=script&lang=js"

import "./EditarViaje.vue?vue&type=style&index=0&id=a195a72a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a195a72a"]])

export default __exports__